export const pt = {
  siteName: 'TudoConversor',
  siteTagline: 'Conversor de Unidades Online Gratuito',
  siteDescription: 'Converta comprimento, peso, temperatura, velocidade, área, volume e mais de 65 tipos de unidades. Calculadora online rápida, precisa e gratuita. Sem registro.',
  nav: {
    home: 'Início',
    about: 'Sobre',
    contact: 'Contato',
    imcCalc: 'Calculadora IMC',
    categories: 'Categorias',
    converters: 'Conversores',
    backToHome: 'Voltar ao início',
    mainNav: 'Navegação principal',
    mobileNav: 'Navegação móvel',
    openMenu: 'Abrir menu de navegação',
    menuTitle: 'Menu de Navegação',
    categoryConverters: 'Categorias de Conversores',
    viewCategory: 'Ver conversores da categoria'
  },
  footer: {
    tagline: 'A plataforma definitiva de conversão. Cálculos precisos, rápidos e gratuitos para engenharia, ciência e seu uso diário.',
    toolsAndCategories: 'Ferramentas & Categorias',
    commonConverters: 'Conversores Comuns',
    engineeringPhysics: 'Engenharia e Física',
    electricity: 'Eletricidade',
    imcCalculator: 'Calculadora de IMC',
    pressureConverter: 'Conversor de Pressão',
    energyConverter: 'Conversor de Energia',
    converters: 'Conversores',
    length: 'Comprimento',
    temperature: 'Temperatura',
    weight: 'Peso',
    volume: 'Volume',
    area: 'Área',
    speed: 'Velocidade',
    time: 'Tempo',
    digitalData: 'Dados Digitais',
    navigation: 'Navegação',
    homePage: 'Página Inicial',
    resourcesArticles: 'Recursos e Artigos',
    aboutUs: 'Sobre o TudoConversor',
    contact: 'Contato',
    legal: 'Legal',
    privacyPolicy: 'Política de Privacidade',
    termsOfService: 'Termos de Serviço',
    dataProtection: 'Proteção de Dados',
    cookiesPolicy: 'Política de Cookies',
    legalNotice: 'Aviso Legal',
    copyright: 'Todos os direitos reservados.',
    builtFor: 'Construído para máxima precisão.',
    footerLabel: 'Rodapé do site'
  },
  cookie: {
    title: 'Aviso de Cookies e Privacidade',
    description: 'Utilizamos cookies para personalizar o conteúdo, os anúncios e melhorar a sua experiência. Ao continuar navegando, você concorda com o uso dessas tecnologias conforme nossa ',
    cookiesPolicy: 'Política de Cookies',
    accept: 'Aceitar cookies',
    reject: 'Recusar'
  },
  converter: {
    category: 'Categoria',
    selectCategory: 'Selecionar Categoria',
    converter: 'Conversor',
    selectConverter: 'Selecionar Conversor',
    value: 'Valor',
    result: 'Resultado',
    from: 'De',
    to: 'Para',
    fromUnit: 'Unidade de origem',
    toUnit: 'Unidade de destino',
    swap: 'Inverter unidades'
  },
  home: {
    heroTitle: 'O Conversor de Unidades Mais Completo',
    heroContent: 'Cálculos precisos, instantâneos e gratuitos. Suporte para mais de 72 conversores abrangendo física, engenharia, informática e medidas do dia a dia.',
    top10: 'Top 10 Conversores Mais Acessados',
    allConverters: 'Todos os Conversores',
    exploreTools: 'Explore Nossas 72+ Ferramentas',
    faqTitle: 'Tire Suas Dúvidas Sobre o TudoConversor',
    howItWorksTitle: 'Como Funciona a Conversão de Unidades no TudoConversor',
    siSystem: 'Sistema Internacional de Unidades (SI)',
    and: 'e pelo',
    bipm: 'Bureau Internacional de Pesos e Medidas (BIPM)',
    mostSearched: 'Conversões Mais Buscadas no Brasil',
    converters: {
      length: 'Comprimento',
      temperature: 'Temperatura',
      weight: 'Peso e Massa',
      volume: 'Volume',
      area: 'Área',
      speed: 'Velocidade',
      time: 'Tempo',
      pressure: 'Pressão',
      energy: 'Energia',
      density: 'Densidade',
      torque: 'Torque',
      digitalData: 'Dados Digitais',
      dataTransfer: 'Transferência de Dados',
      voltage: 'Tensão Elétrica',
      fuelConsumption: 'Consumo de Combustível',
      luminance: 'Luminância',
      viscosity: 'Viscosidade',
      frequency: 'Frequência',
      imcCalc: 'Calculadora de IMC',
      shoeSize: 'Tamanho de Calçado'
    },
    popular: {
      lengthDesc: 'm, km, milhas, pés',
      weightDesc: 'kg, lb, gramas, oz',
      temperatureDesc: 'Celsius, Fahrenheit, K',
      volumeDesc: 'Litros, galões, m³',
      speedDesc: 'km/h, mph, nós',
      areaDesc: 'm², hectares, acres',
      voltageDesc: 'V, mV, kV',
      accelerationDesc: 'm/s², km/h²',
      densityDesc: 'kg/m³, g/cm³',
      timeDesc: 'Segundos, Horas, Dias'
    }
  },
  converterPage: {
    quickConversions: 'Conversões Rápidas',
    relatedConverters: 'Conversores Relacionados'
  },
  categoryPage: {
    availableConverters: 'Conversores Disponíveis',
    exploreCategory: 'Explorar Categoria'
  },
  unitPair: {
    converterTitle: 'Conversor de',
    instantFree: 'Instantâneo e Gratuito',
    typeBelow: 'Digite o valor abaixo para converter',
    faqTitle: 'Perguntas Frequentes',
    backToConverter: 'Voltar para o conversor principal',
    faq1Title: 'Como converter?',
    faq1Answer: 'Basta digitar o valor no campo de origem e o resultado aparecerá automaticamente.',
    faq2Title: 'A conversão é exata?',
    faq2Answer: 'Sim, utilizamos as definições oficiais de conversão de unidades para garantir precisão máxima.',
    faq3Title: 'Posso inverter as unidades?',
    faq3Answer: 'Sim, utilize o botão com as setas para inverter a direção da conversão.',
    faq4Title: 'É gratuito?',
    faq4Answer: 'Completamente gratuito, sem limite de uso ou necessidade de registro.'
  },
  notFound: {
    title: 'Página Não Encontrada',
    message: 'A página que você está procurando não existe ou foi movida.',
    backHome: 'Voltar ao Início'
  },
  about: {
    title: 'Sobre o TudoConversor',
    forWho: 'Para Quem é Feito?',
    user1: 'Estudantes',
    user2: 'Profissionais',
    user3: 'Uso Diário',
    precision: 'Nosso Compromisso com a Precisão',
    questions: 'Tem alguma dúvida?',
    usefulPages: 'Páginas Úteis',
    backToConverter: 'Voltar aos Conversores',
    contactUs: 'Fale Conosco'
  },
  contact: {
    title: 'Entre em Contato',
    successTitle: 'Mensagem Enviada!',
    fullName: 'Nome Completo',
    email: 'E-mail',
    message: 'Sua Mensagem',
    responseTime: 'Respondemos em até 24 horas',
    helpTopics: 'Tópicos de Ajuda',
    about: 'Dúvidas sobre ferramentas',
    faq: 'Perguntas Frequentes',
    faqDesc: 'Veja nossa seção de ajuda',
    transparency: 'Transparência e Confiança',
    usefulPages: 'Links Úteis',
    backToConverter: 'Voltar aos Conversores',
    privacyPolicy: 'Política de Privacidade',
    send: 'Enviar Mensagem'
  },
  imc: {
    title: 'Calculadora de IMC',
    weight: 'Peso (kg)',
    height: 'Altura (cm)',
    sex: 'Sexo',
    male: 'Masculino',
    female: 'Feminino',
    calculate: 'Calcular IMC',
    yourResult: 'Seu Resultado',
    hide: 'Ocultar',
    referenceTable: 'Tabela de Referência',
    underweight: 'Abaixo do peso',
    normal: 'Peso normal',
    overweight: 'Sobrepeso',
    obese1: 'Obesidade Grau I',
    obese2: 'Obesidade Grau II',
    obese3: 'Obesidade Grau III',
    below185: 'Menor que 18,5',
    range185: '18,5 a 24,9',
    range250: '25,0 a 29,9',
    range300: '30,0 a 34,9',
    range350: '35,0 a 39,9',
    above400: 'Maior que 40,0',
    description: 'Calcule seu Índice de Massa Corporal (IMC) facilmente.'
  },
  resources: {
    title: 'Recursos e Artigos',
    metricVsImperial: 'Sistema Métrico vs Imperial',
    temperatureGuide: 'Guia de Escalas de Temperatura',
    electricityGuide: 'Fundamentos de Unidades Elétricas',
    goToLengthConverter: 'Ir para Conversor de Comprimento',
    goToTempConverter: 'Ir para Conversor de Temperatura'
  },
  seo: {
    homeTitle: 'TudoConversor | O Conversor de Unidades Mais Completo',
    homeDescription: 'Converta unidades de comprimento, peso, temperatura, área e mais de 65 categorias no TudoConversor. Ferramenta gratuita, rápida e com precisão científica.',
    aboutTitle: 'Sobre Nós | TudoConversor',
    contactTitle: 'Contato | TudoConversor',
    imcTitle: 'Calculadora de IMC Online e Gratuita | TudoConversor',
    imcDescription: 'Calcule seu Índice de Massa Corporal (IMC) com nossa ferramenta online precisa. Veja sua classificação na tabela de referência da OMS.',
    resourcesTitle: 'Recursos e Guias | TudoConversor',
    notFoundTitle: 'Página Não Encontrada | TudoConversor',
    converterTitle: 'Conversor de Unidades',
    converterDescription: 'Ferramenta online gratuita para conversão de unidades.',
    categoryTitle: 'Categoria de Conversão',
    unitPairDescription: 'Converta unidades instantaneamente de forma gratuita.'
  },
  categories: {
    common: 'Comuns',
    engineering: 'Engenharia',
    heat: 'Calor',
    fluids: 'Fluidos',
    light: 'Luz',
    electricity: 'Eletricidade',
    magnetism: 'Magnetismo',
    radiology: 'Radiologia',
    other: 'Outros'
  },
  units: {
    length: 'Comprimento',
    metro: 'Metro',
    quilometro: 'Quilômetro',
    centimetro: 'Centímetro',
    milimetro: 'Milímetro',
    milha: 'Milha',
    jarda: 'Jarda',
    pe: 'Pé',
    polegada: 'Polegada',
    temperature: 'Temperatura',
    celsius: 'Celsius',
    fahrenheit: 'Fahrenheit',
    kelvin: 'Kelvin',
    weight: 'Peso e Massa',
    quilograma: 'Quilograma',
    grama: 'Grama',
    miligrama: 'Miligrama',
    tonelada: 'Tonelada',
    libra: 'Libra',
    onca: 'Onça',
    volume: 'Volume',
    area: 'Área',
    time: 'Tempo',
    speed: 'Velocidade',
    shoeSize: 'Tamanho de Calçado',
    density: 'Densidade',
    angularVelocity: 'Velocidade Angular',
    acceleration: 'Aceleração',
    angularAcceleration: 'Aceleração Angular',
    specificVolume: 'Volume Específico',
    momentOfInertia: 'Momento de Inércia',
    torque: 'Torque',
    pressure: 'Pressão',
    energy: 'Energia',
    fuelEfficiency: 'Eficiência de Combustível',
    temperatureInterval: 'Intervalo de Temperatura',
    thermalExpansion: 'Expansão Térmica',
    thermalResistance: 'Resistência Térmica',
    thermalConductivity: 'Condutividade Térmica',
    specificHeatCapacity: 'Capacidade Calorífica Específica',
    thermalEnergyDensity: 'Densidade de Energia Térmica',
    heatFluxDensity: 'Densidade de Fluxo de Calor',
    heatTransferCoefficient: 'Coeficiente de Transferência de Calor',
    volumetricFlow: 'Vazão Volumétrica',
    massFlow: 'Vazão de Massa',
    molarFlow: 'Vazão Molar',
    massFluxDensity: 'Densidade de Fluxo de Massa',
    molarConcentration: 'Concentração Molar',
    solutionConcentration: 'Concentração de Solução',
    dynamicViscosity: 'Viscosidade Dinâmica',
    kinematicViscosity: 'Viscosidade Cinemática',
    surfaceTension: 'Tensão Superficial',
    permeability: 'Permeabilidade',
    luminance: 'Luminância',
    luminousIntensity: 'Intensidade Luminosa',
    illumination: 'Iluminação',
    digitalImageResolution: 'Resolução de Imagem Digital',
    frequency: 'Frequência',
    charge: 'Carga Elétrica',
    current: 'Corrente Elétrica',
    voltage: 'Tensão Elétrica',
    linearChargeDensity: 'Densidade de Carga Linear',
    surfaceChargeDensity: 'Densidade de Carga Superficial',
    volumeChargeDensity: 'Densidade de Carga Volumétrica',
    linearCurrentDensity: 'Densidade de Corrente Linear',
    surfaceCurrentDensity: 'Densidade de Corrente Superficial',
    electricFieldStrength: 'Intensidade de Campo Elétrico',
    resistance: 'Resistência Elétrica',
    electricalResistivity: 'Resistividade Elétrica',
    conductance: 'Condutância',
    electricalConductivity: 'Condutividade Elétrica',
    capacitance: 'Capacitância',
    inductance: 'Indutância',
    magnetomotiveForce: 'Força Magnetomotriz',
    magneticFieldIntensity: 'Intensidade de Campo Magnético',
    magneticFlux: 'Fluxo Magnético',
    magneticFluxDensity: 'Densidade de Fluxo Magnético',
    radiation: 'Radiação',
    radiationActivity: 'Atividade de Radiação',
    radiationExposure: 'Exposição à Radiação',
    absorbedDose: 'Dose Absorvida',
    dataStorage: 'Armazenamento de Dados',
    dataTransfer: 'Transferência de Dados',
    typography: 'Tipografia',
    fluidFlow: 'Vazão de Fluidos',
    concentration: 'Concentração',
    viscosity: 'Viscosidade',
    electricalProperties: 'Propriedades Elétricas',
    magneticProperties: 'Propriedades Magnéticas',
    thermalProperties: 'Propriedades Térmicas'
  }
};